<img #canvas alt="bar-code" />
